const DEFAULT_RUNTIME_CONFIG = {
  posthogProjectToken: '',
  posthogHost: 'https://us.i.posthog.com',
  posthogUiHost: 'https://us.posthog.com',
  deploymentEnvironment: 'local',
};

export const getRuntimeConfig = () => {
  if (typeof window === 'undefined' || !window.__RUNTIME_CONFIG__) {
    return DEFAULT_RUNTIME_CONFIG;
  }

  return {
    ...DEFAULT_RUNTIME_CONFIG,
    ...window.__RUNTIME_CONFIG__,
  };
};

export default getRuntimeConfig;
